/*
  HALO Marquee: faixa de logos em loop contínuo (seção HALO Na Mídia).
  O movimento é uma animação CSS (roda na GPU). O JavaScript só mede a lista, cria as cópias
  necessárias para cobrir a largura sem buracos e calcula a duração a partir da velocidade em px/s.
  Sem JavaScript, ou com movimento reduzido, os logos ficam parados e centralizados.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-marquee')) return;

  class HaloMarquee extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      this.track = this.querySelector('[data-marquee-track]');
      this.list = this.querySelector('[data-marquee-list]');
      this.toggle = this.querySelector('[data-marquee-toggle]');
      if (!this.track || !this.list) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.animate !== 'true' || reduce) {
        this.classList.add('is-static');
        if (this.toggle) this.toggle.hidden = true;
        return;
      }

      this.speed = Math.max(5, parseFloat(this.dataset.speed) || 40);
      if (this.dataset.direction === 'ltr') this.style.setProperty('--hm-dir', 'reverse');
      this.clones = [];

      var self = this;
      this.ro = new ResizeObserver(function () {
        self.layout();
      });
      this.ro.observe(this);
      this.ro.observe(this.list);

      // Fora da tela, a animação para.
      this.io = new IntersectionObserver(function (entries) {
        self.classList.toggle('is-offscreen', !entries[entries.length - 1].isIntersecting);
      });
      this.io.observe(this);

      if (this.toggle) {
        this.onToggle = function () {
          self.setPaused(!self.classList.contains('is-paused'));
        };
        this.toggle.addEventListener('click', this.onToggle);
      }

      // Editor de temas: selecionar um logo pausa a faixa para facilitar a edição.
      this.onBlockSelect = function (e) {
        if (self.contains(e.target)) self.classList.add('is-editing');
      };
      this.onBlockDeselect = function (e) {
        if (self.contains(e.target)) self.classList.remove('is-editing');
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.layout();
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.toggle && this.onToggle) this.toggle.removeEventListener('click', this.onToggle);
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    layout() {
      var listWidth = this.list.offsetWidth;
      var boxWidth = this.offsetWidth;
      if (!listWidth || !boxWidth) return;

      // Cópias suficientes para que, ao andar uma lista inteira, a faixa continue cheia.
      var needed = Math.max(1, Math.ceil(boxWidth / listWidth));
      while (this.clones.length < needed) {
        var clone = this.list.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-marquee-list');
        Array.prototype.forEach.call(clone.querySelectorAll('img'), function (img) {
          img.setAttribute('alt', '');
        });
        Array.prototype.forEach.call(clone.querySelectorAll('a, button'), function (el) {
          el.setAttribute('tabindex', '-1');
        });
        Array.prototype.forEach.call(clone.querySelectorAll('[data-shopify-editor-block]'), function (el) {
          el.removeAttribute('data-shopify-editor-block');
        });
        this.track.appendChild(clone);
        this.clones.push(clone);
      }

      this.style.setProperty('--hm-shift', -listWidth + 'px');
      this.style.setProperty('--hm-duration', (listWidth / this.speed).toFixed(2) + 's');
      this.classList.add('is-running');
    }

    setPaused(paused) {
      this.classList.toggle('is-paused', paused);
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.toggle.textContent = paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
    }
  }

  customElements.define('halo-marquee', HaloMarquee);
})();
